import { render, staticRenderFns } from "./selectGift.vue.js?vue&type=template&id=b08e10ec&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./selectGift.vue?vue&type=template&id=b08e10ec&scoped=true"
import script from "./selectGift.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./selectGift.vue?vue&type=script&lang=js"
export * from "./selectGift.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./selectGift.vue?vue&type=script&lang=js"
import style0 from "./selectGift.vue.scss?vue&type=style&index=0&id=b08e10ec&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./selectGift.vue?vue&type=style&index=0&id=b08e10ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08e10ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b08e10ec')) {
      api.createRecord('b08e10ec', component.options)
    } else {
      api.reload('b08e10ec', component.options)
    }
    module.hot.accept("./selectGift.vue.js?vue&type=template&id=b08e10ec&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./selectGift.vue?vue&type=template&id=b08e10ec&scoped=true", function () {
      api.rerender('b08e10ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/Dialog/selectGift.vue"
export default component.exports